/**
 * NomenclatureSelect — комбобокс з пошуком для вибору номенклатури у рядках
 * табличної частини документів (рішення власника 2026-07-25: «надо делать
 * комбобокс уже» — простиня <select> на 1300+ позицій незручна).
 *
 * Обгортка над SearchSelect: сам вантажить довідник (спільний кеш
 * 'nomenclature-full'), пошук за кодом і назвою. Фільтр kind:
 * goods (не-послуги) / services / all. Поточне значення рядка завжди
 * лишається у списку (навіть якщо не проходить фільтр kind — щоб
 * збережений документ показував свій товар).
 */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { nomenclature as nomApi } from '@/api/catalogs';
import SearchSelect from '@/components/SearchSelect';

interface Props {
  value: string;
  onChange: (nomenclatureId: string) => void;
  disabled?: boolean;
  kind?: 'goods' | 'services' | 'all';
  placeholder?: string;
}

export default function NomenclatureSelect({
  value, onChange, disabled = false, kind = 'all',
  placeholder = '— почніть вводити назву або код —',
}: Props) {
  const nomList = useQuery({
    queryKey: ['nomenclature-full'],
    queryFn: () => nomApi.listAll(),
  });

  const items = useMemo(() => {
    const all = nomList.data?.items ?? [];
    return all
      .filter((n) => {
        if (n.id === value) return true;
        if (n.deletion_mark) return false;
        if (kind === 'goods') return !n.is_service;
        if (kind === 'services') return !!n.is_service;
        return true;
      })
      .map((n) => ({ id: n.id, label: n.name, hint: n.code || null }));
  }, [nomList.data, kind, value]);

  return (
    <SearchSelect
      items={items}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
}
